export const MONACO_EDITOR_PROPS = {
    atId: { type: String, default: "monaco-editor" },
    autoResize: { type: Boolean, default: false },
    value: { type: String, default: "" },
    diffValue: { type: String, default: "" },
    language: { type: String, default: "javascript" },
    readonly: { type: Boolean, default: false },
    theme: { type: String, default: "" },
    contentNotValid: { type: Boolean, default: false },
    receiveValidStatus: { type: Boolean, default: false },
    addGlobalContent: { type: String, default: "" },
    suggestions: { type: Array, default: () => [] } // suggestion list => ex: [ { label: "", value: "" } ]
};
